<template>
  <div class="zcbody">
    <div class="protocol-accept1">
      <span><font style="color:red">*</font>&nbsp;<b>企业联系人</b>
        (可添加业务人员作为采购订单接收人，<font style="color:red">手机号不能重复</font>)</span>
      <el-button size="mini" type="success" class="pull-right" @click="addtable">新增</el-button>
    </div>
    <el-table :data="tableSDA" border style="width: 100%" max-height="420" tooltip-effect :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="cisbusiness" label="是否接收通知信息" width="140"></el-table-column>
      <el-table-column prop="cusername" label="姓名" width="90"></el-table-column>
      <el-table-column prop="cgender" label="性别" width="60"></el-table-column>
      <el-table-column prop="cdepname" label="部门"></el-table-column>
      <el-table-column prop="cposition" label="职位"></el-table-column>
      <el-table-column prop="clandine" label="座机" width="120"></el-table-column>
      <el-table-column prop="cusertel" label="手机" width="120"></el-table-column>
      <el-table-column prop="cuseremail" label="电子邮箱" width="160"></el-table-column>

      <el-table-column prop="name" label="操作" width="160">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="regit(scope.row, scope.$index)" style="marign-right: 5px">修改</el-button>
          <el-button size="mini" type="danger" @click="del(scope.row, scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="新增企业联系人" :visible.sync="dialogFormVisible" customClass="way sadform" :append-to-body="true">
      <el-form ref="sdaruleForm" :rules="sdarules" :model="sdaform" label-width="110px" class="form01">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名:" prop="cusername">
              <el-input v-model="sdaform.cusername" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别:" prop="cgender">
              <el-select v-model="sdaform.cgender" placeholder="请选择">
                <el-option label="男" value="男"></el-option>
                <el-option label="女" value="女"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职位:" prop="cposition">
              <el-input v-model="sdaform.cposition" placeholder="请输入职位"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机:" prop="cusertel">
              <el-input v-model="sdaform.cusertel" placeholder="请输入手机"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="部门:" prop="cdepname">
              <el-input v-model="sdaform.cdepname" placeholder="请输入部门"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="座机:" prop="clandine">
              <el-input v-model="sdaform.clandine" placeholder="请输入座机"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱:" prop="cuseremail">
              <el-input v-model="sdaform.cuseremail" placeholder="请输入邮箱"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否通知接收信息:" prop="cisbusiness">
              <el-select v-model="sdaform.cisbusiness" placeholder="请选择">
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closesad('sdaruleForm')">取 消</el-button>
        <el-button type="success" @click="confirm('sdaruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    sdatable: { Type: Object },
  },
  data() {
    var email = (rule, value, callback) => {
      var patterns =
        /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
      if (!patterns.test(value)) {
        callback(new Error("邮箱输入有误"));
      } else {
        callback();
      }
    };
    var tel = (rule, value, callback) => {
      var pattern = /^1[3-9]\d{9}$/;
      if (!pattern.test(value)) {
        callback(new Error("手机号输入有误"));
      } else {
        callback();
      }
    };
    return {
      state: "-1",
      dialogFormVisible: false,
      tableSDA: this.sdatable,
      sdaform: {
        cusername: "",
        cgender: "",
        cposition: "",
        cusertel: "",
        cdepname: "",
        clandine: "",
        cuseremail: "",
        cisbusiness: "",
      },
      sdarules: {
        cusername: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        cgender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        cposition: [{ required: true, message: "请输入职位", trigger: "blur" }],
        cusertel: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: tel, trigger: "blur" },
        ],
        cdepname: [{ required: true, message: "请输入部门", trigger: "blur" }],
        cuseremail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
        ],
        cisbusiness: [
          { required: true, message: "请选择是否业务人员", trigger: "blur" },
        ],
      },
    };
  },
  created() {},
  methods: {
    addtable() {
      this.state = "-1";
      this.dialogFormVisible = true;
      this.sdaform = {
        cusername: "",
        cgender: "",
        cposition: "",
        cusertel: "",
        cdepname: "",
        clandine: "",
        cuseremail: "",
        cisbusiness: "",
      };
    },
    closesad(sdaruleForm) {
      this.$refs[sdaruleForm].resetFields();
      this.dialogFormVisible = false;
    },
    confirm(sdaruleForm) {
      this.$refs[sdaruleForm].validate((valid) => {
        if (valid) {
          console.log(this.state);
          if (this.state == "-1") {
            this.tableSDA.push(this.sdaform);
          } else {
            this.tableSDA.splice(this.state, 1);
            console.log(this.tableSDA);
            setTimeout(() => {
              this.tableSDA.push(this.sdaform);
              this.$emit("sdalist", this.tableSDA);
            }, 30);
          }
          this.dialogFormVisible = false;

          console.log(this.tableSDA);
        } else {
          return false;
        }
      });
    },
    regit(row, i) {
      this.state = i;
      this.sdaform = row;
      this.dialogFormVisible = true;
    },
    del(row, i) {
      this.tableSDA.splice(i, 1);
    },
  },
};
</script>
<style scoped>
@import url(../../../assets/css/reg.css);
</style>